import { render, staticRenderFns } from "./appAssetMetadata.vue?vue&type=template&id=3ab96b42&scoped=true"
import script from "./appAssetMetadata.vue?vue&type=script&lang=js"
export * from "./appAssetMetadata.vue?vue&type=script&lang=js"
import style0 from "./appAssetMetadata.vue?vue&type=style&index=0&id=3ab96b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab96b42",
  null
  
)

export default component.exports